import React from "react";
import SectionWrapper from "../ui/SectionWrapper";

const AboutUs: React.FC = () => {
  return (
    <SectionWrapper>
      {/* ================= HERO ================= */}
      <div className="rounded-b-lg bg-[#F2F4F7] overflow-hidden mb-[100px]">

        {/* MOBILE → COLUMN | DESKTOP → ROW */}
        <div className="flex flex-col lg:flex-row">
            <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full h-[220px] sm:h-[280px] lg:w-[300px] lg:h-[600px] overflow-hidden flex items-center justify-center">
                <img
                 src="/assets/optimized/about-us-1200.jpg"
                    alt="About Us. We offer BPO Services, Generative AI Web Development and Postal Address Location Services."
                className="
                    w-full h-full object-cover object-top

                    lg:w-auto lg:h-full lg:max-w-none
                    lg:object-center
                    lg:scale-[0.75]
                    lg:translate-x-16 lg:-translate-y-[14%]
                "
                />
            </div>
        </div>

          {/* LEFT CONTENT */}
          <div className="flex-1 px-8 py-8 space-y-4 order-2 lg:order-1">
            <p className=" text-[15px] leading-relaxed text-[#4B5C73]">
              We have been operating for 25 years. Our background is UK consumer data,
              designing, building and managing large databases that included in depth
              demographic, behavioral and purchase history. We expanded our area of
              coverage to include Australian based clients. Companies who have used our
              services on a contracted basis include AXA, FT and Mercedes Benz UK.
            </p>

            <p className="text-[15px] leading-relaxed text-[#4B5C73]">
              BPO services we launched 15 years ago and these have expanded, mainly
              focusing on Identity Verification (IDV), Know Your Customer (KYC) and
              Pharmaceutical sectors. We have teams of personnel dedicated to respective
              clients so that each member essentially becomes part of our client’s own
              staff except we are responsible for all recruitment, training, HR and salaries of of the staff.
            </p>

            <p className="text-[15px] leading-relaxed text-[#4B5C73]">
              Address Finder is our own service developed specifically for UK companies
              who collect residential addresses of their customers and prospects. Not
              only do we provide cost savings to our clients, in addition there are other
              data items, most notably UPRN and geo co-ordinates along with property
              value, that can be provided all within the same simple API.
            </p>

            <p className="text-[15px] leading-relaxed text-[#4B5C73]">
              Our main office is located in Manila, Philippines. Chosen as location for
              the vast pool of educated native English speakers who are renowned for
              looking after clients.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default AboutUs;
